// neurotrader-admin/src/components/AdminHeader.js
import React, {useState, useEffect, useRef} from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { FiUsers, FiUser, FiLogOut } from 'react-icons/fi';
// Reutiliza o CSS do header do painel principal para consistência
import './AdminHeader.css';

const AdminHeader = () => {
    const [onlineUsers, setOnlineUsers] = useState(0);
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const { user, logout } = useAuth();
    const dropdownRef = useRef(null)

    useEffect(() => {
        const fetchOnlineUsers = async () => {
            if (!user?.token) return;
            try {
                const { data } = await api.get('/api/admin/online-users', {
                    headers: { Authorization: `Bearer ${user.token}` }
                });
                setOnlineUsers(data.count);
            } catch (error) {
                console.error("Erro ao buscar usuários online:", error);
            }
        };

        fetchOnlineUsers();
        const interval = setInterval(fetchOnlineUsers, 30000);
        return () => clearInterval(interval);
    }, [user]);

    // NOVO: useEffect para fechar o dropdown ao clicar fora
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        // Adiciona o listener
        document.addEventListener("mousedown", handleClickOutside);
        // Limpeza
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [dropdownRef]);

    return (
        <header className="header">
            <div className="header-left">
                {/* Podemos adicionar um botão de hamburger aqui no futuro se for responsivo */}
                <h2 className="header-title">Painel de Administração</h2>
            </div>

            <div className="header-right">
                <div className="header-widget">
                    <FiUsers className="header-widget-icon"/>
                    <div className="header-widget-text">
                        <span>Usuários Online</span>
                        <strong>{onlineUsers}</strong>
                    </div>
                </div>
                <div className="header-separator"></div>

                {/* --- NOVO: DROPDOWN DE USUÁRIO --- */}
                <div className="user-menu-container" ref={dropdownRef}>
                    {/* O botão que abre/fecha o dropdown */}
                    <button className="user-menu-button" onClick={() => setDropdownOpen(!isDropdownOpen)}>
                        <FiUser/>
                    </button>

                    {/* O menu dropdown, renderizado condicionalmente */}
                    {isDropdownOpen && (
                        <div className="user-dropdown-menu">
                            <div className="dropdown-header">
                                <span>Logado como:</span>
                                <strong>{user?.email}</strong>
                            </div>
                            <button onClick={logout} className="dropdown-item logout">
                                <FiLogOut/>
                                <span>Sair</span>
                            </button>
                        </div>
                    )}
                </div>

            </div>
        </header>
    );
};

export default AdminHeader;